/* Copyright (C) 2022 ev-i Informationstechnologie GmbH */

export enum ProjectStatusInt {
    ACTIVE = 0,
    INACTIVE = 6,
    PLANNING_NOTIFICATION_PROJECT = 10
}
